import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IOrganizationState} from '@app/stores';

const selectOrganization = createFeatureSelector<IOrganizationState>('organizations');

export const getOrganization = createSelector(selectOrganization, (state: IOrganizationState) => state.organization);

export const getOrganizationSuccess = createSelector(selectOrganization, (state: IOrganizationState) => state.success);

export const getOrganizationError = createSelector(selectOrganization, (state: IOrganizationState) => state.error);

export const getOrganizations = createSelector(selectOrganization, (state: IOrganizationState) => state.organizations);

export const getOrganizationsListAll = createSelector(selectOrganization, (state: IOrganizationState) => state.organizations);

export const getPaginatedOrganizations = createSelector(selectOrganization, (state: IOrganizationState) => state.paginatedOrganizations);
